export default __webpack_public_path__ + "static/media/ECA_LOGO_FR.60cb0654.png";